import React, { useEffect } from 'react';

import { connect } from 'react-redux';

import TabPanel, { Tab, TabContent } from '../../../components/TabPanel';

import RuleSettings from './RuleSettings';
import EmailSettings from './EmailSettings';

import * as ServiceManagementActions from '../../../actions/serviceManagementActions';

import classes from './SettingsPage.module.css';

const SettingsPage = ({
    ...props
}) => {
    useEffect(() => {
    }, []);

    return (
        <div className={classes.SettingsPage}>
            <TabPanel
                aria-label="Service Management Setting Options"
                classes={{
                    root: classes.tabPanel
                }}
            >
                <Tab title="Email to Service Request">
                    <TabContent
                        classes={{
                            root: classes.tabContent
                        }}
                    >
                        <div className={classes.titleArea}>
                            Email to Service Request Settings
                        </div>
                        <EmailSettings />
                    </TabContent>
                </Tab>

                <Tab title="Rule Fault To Service Call">
                    <TabContent
                        classes={{
                            root: classes.tabContent
                        }}
                    >
                        <div className={classes.titleArea}>
                            Rule Fault to Service Request Settings
                        </div>
                        <RuleSettings />
                    </TabContent>
                </Tab>
            </TabPanel>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo
    };
};

const mapDispatchToProps = {
    ...ServiceManagementActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);
